if (!customElements.get('m-image-layer')) {
    class MImageLayer extends HTMLElement {
        constructor() {
            super();
            this.enableParallax = false;
        }

        connectedCallback() {
            this.enableParallax = this.dataset.enableParallax === "true";
            if (this.enableParallax) {
                this.initElements();
                MinimogTheme.Motion.inView(this, this.initAnimations.bind(this));
            }
        }

        initElements() {
            this.firstImage = this.querySelector(".m-image-with-text__image-first");
            this.secondImage = this.querySelector(".m-image-with-text__image-second");
            if (!this.firstImage || !this.secondImage) {
                console.error("First or second image elements are missing.");
                return;
            }
        }

        initAnimations() {
            if (this.secondImage) {
                this.animateElement(this.secondImage, ["translateY(30%)", "translateX(0)"]);
            } else {
                console.error("Second image element is missing during animation initialization.");
            }

            if (this.firstImage) {
                this.animateElement(this.firstImage, ["translateY(-5%)", "translateX(0)"]);
            } else {
                console.error("First image element is missing during animation initialization.");
            }
        }

        animateElement(element, transformations) {
            if (!MinimogTheme || !MinimogTheme.Motion || !MinimogTheme.Motion.scroll || !MinimogTheme.Motion.animate) {
                console.error("MinimogTheme or its Motion components are not defined.");
                return;
            }

            MinimogTheme.Motion.scroll(
                MinimogTheme.Motion.animate(element, { transform: transformations }, { easing: "linear" }),
                { target: element, offset: ["start end", "end start"] }
            );
        }
    }

    customElements.define("m-image-layer", MImageLayer);
}
